import React, { useState } from "react";
import "./FloatLabel.css";

const FloatLabel = ({ children, label, value, required=false }) => {
  const [focus, setFocus] = useState(false);
  // console.log("FloatLabel rendered with and value:", { children, label, value });
  const labelClass =
    focus || (value && value.length !== 0) ? "label label-float" : "label";

  return (
    <div className="float-label">
      {React.cloneElement(children, {
        onFocus: () => setFocus(true),
        onBlur: () => setFocus(false),
      })}
      <label className={labelClass}>
        {label}
        {required && <span style={{ color: "red", marginRight: 4 }}>*</span>}
      </label>
    </div>
  );
};

export default FloatLabel;
